namespace RioERP.Masters {
    export interface AttemptsForm {
        Name: Serenity.StringEditor;
        AttemptDate: Serenity.DateEditor;
        CourseId: Serenity.LookupEditor;
        LevelId: Serenity.LookupEditor;
    }

    export class AttemptsForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.Attempts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AttemptsForm.init)  {
                AttemptsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;

                Q.initFormType(AttemptsForm, [
                    'Name', w0,
                    'AttemptDate', w1,
                    'CourseId', w2,
                    'LevelId', w2
                ]);
            }
        }
    }
}
